import { Component, OnInit } from '@angular/core';
import { StepTemplateBaseComponent } from '../step-template-base/step-template-base.component';
import { AuthService } from 'app/core/services/auth.service';
import { Router } from '@angular/router';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { ChildState } from 'app/core/components/dynamic-onboarding/dynamic-onboarding.component';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';

@Component({
  selector: 'itpx-gdpr-card',
  templateUrl: './gdpr-card.component.html',
  styleUrls: ['./gdpr-card.component.css']
})
export class GdprCardComponent extends StepTemplateBaseComponent {
  private hideAbort = false;
  private form: FormGroup;
  private checkbox: FormControl;

  constructor(
    private authService: AuthService,
    private router: Router,
    private modalService: SmartModalService,
    private fb: FormBuilder
  ) {
    super();
  }

  ngOnInit() {
    this.form = this.fb.group({

    })
    this.checkbox = new FormControl(false);
    this.checkbox
    // this.parentForm.get('gdpr')
    .valueChanges
      // .startWith(!!this.parentForm.get('gdpr').value)
      .subscribe(val => this.status.emit(val ? ChildState.enabled : ChildState.disabled));

    this.next.bindToLifecycle(this).filter(input => input === this.id).subscribe(_ => {
      // this.parentForm.get('gdpr')
      this.checkbox.disable({ emitEvent: false });
      this.hideAbort = true;
      this.status.emit(ChildState.done);
    });
  }

  async onCancel() {
    await this.authService.logout();
  }
}


// WEBPACK FOOTER //
// ./src/app/core/components/dynamic-onboarding/gdpr-card/gdpr-card.component.ts